import { tracking as barkTrackingLogEvent, _t } from '@bark/bark-core';
import BuyerApi from '../../helpers/buyer-api';
import ReviewStars from '../../helpers/review-stars';

export default function () {
	const { QS } = window;
	const buyerApi = BuyerApi();

	const show = async (state, marketplaceType, meta) => {
		const topFiveSuggestedSellers = await getTopFiveSuggestedSellers(
			state?.projectDetail?.id,
			state?.bpvid,
		);

		if (topFiveSuggestedSellers?.length) {
			barkTrackingLogEvent('marketplace-seller-list', 'request-replies-view', {
				project_id: state?.projectDetail?.id,
				buyer_user_id: state?.buyerDetails?.data?.id,
			});

			buildConfirmationHeader(marketplaceType, meta);
			buildSellerRows(topFiveSuggestedSellers);
			bindListeners(
				state?.projectDetail?.id,
				state?.bpvid,
				state?.matches?.sellerList,
				state?.buyerDetails?.data?.id,
				state?.buyerDetails?.data?.telephone,
			);
			$('#marketplace-buyer-quote-upsell-modal').modal('show');
		}
	};

	const buildConfirmationHeader = (marketplaceType, meta) => {
		const { Handlebars } = window;
		const headerTemplate = Handlebars.compile(
			document.getElementById('marketplace-buyer-quote-upsell-modal-header-template')
				.innerHTML,
		);

		let headerText = null;
		let subHeaderText = null;

		switch (marketplaceType) {
			case 'marketplace-messages':
				headerText = _t(
					'buyer_seller-list_request-quote:marketplace-upsell.message.header',
				);
				subHeaderText = _t(
					'buyer_seller-list_request-quote:marketplace-upsell.message.sub',
				);
				break;
			case 'marketplace-booking':
				headerText = _t(
					'buyer_seller-list_request-quote:marketplace-upsell.booking.header',
				);
				if (meta?.day && meta?.time) {
					subHeaderText = _t(
						'buyer_seller-list_request-quote:marketplace-upsell.booking.sub',
						{ confirmation_day: meta.day, confirmation_time: meta.time },
					);
				}
				break;
			case 'marketplace-enquiry':
				if (meta?.messageSent) {
					headerText = _t(
						'buyer_seller-list_request-quote:marketplace-upsell.message.header',
					);
					subHeaderText = _t(
						'buyer_seller-list_request-quote:marketplace-upsell.message.sub',
					);
				}
				break;
		}

		$('#marketplace-buyer-quote-upsell-modal-header-container')
			.empty()
			.append(headerTemplate({ headerText, subHeaderText }));
	};

	const buildSellerRows = (sellers) => {
		const { Handlebars } = window;
		const sellersTemplate = Handlebars.compile(
			document.getElementById('marketplace-buyer-quote-upsell-modal-sellers-template')
				.innerHTML,
		);
		$('#marketplace-buyer-quote-upsell-modal-sellers-container')
			.empty()
			.append(sellersTemplate({ sellers }));
	};

	const getTrackingData = (sellerProfileIdArray, sellerList) => {
		const sellers = sellerProfileIdArray
			.map((sellerId) => {
				const seller = sellerList.find((x) => x.id === sellerId);

				const marketplaceMatches = {
					'marketplace-enquiry': 'enquiry',
					'marketplace-booking': 'booking',
					'marketplace-messages': 'messages',
				};
				const matchTypes = seller?.attributes?.match_types ?? [];
				const marketplaceCtas = matchTypes.length
					? matchTypes
							.filter((x) => Object.keys(marketplaceMatches).includes(x))
							.map((x) => marketplaceMatches[x])
							.join(', ')
					: 'NULL';

				return `${sellerId} - ${marketplaceCtas}`;
			})
			.join('; ');

		return {
			list: 'marketplace',
			sellers,
		};
	};

	const bindListeners = (projectId, bpvid, sellerList, buyerUserId, buyerPhone) => {
		const checkboxes = $(
			'input[type=checkbox][name=marketplace-request-quote-upsell-sellers]',
		);
		let enabledSellers = [];
		checkboxes.change(function () {
			enabledSellers = checkboxes
				.filter(':checked')
				.map(function () {
					return this.value;
				})
				.get(); // Get array.
			if (enabledSellers.length > 0) {
				$('#marketplace-buyer-quote-upsell-modal .js-marketplace-rqfa-btn').prop(
					'disabled',
					false,
				);
			} else {
				$('#marketplace-buyer-quote-upsell-modal .js-marketplace-rqfa-btn').prop(
					'disabled',
					true,
				);
			}
		});

		$('#marketplace-buyer-quote-upsell-modal .js-marketplace-rqfa-btn')
			.off('click.requestFromAll')
			.on('click.requestFromAll', function () {
				$(this).children('.spinner-border').removeClass('d-none');

				$(this).attr('disabled', true);

				const upsellContainer = document.getElementById(
					'marketplace-buyer-quote-upsell-modal-sellers-container',
				);
				const selectedSellers = upsellContainer.getElementsByTagName('INPUT');
				let sellerProfileIdArray = [];
				for (var i = 0; i < selectedSellers.length; i++) {
					if (selectedSellers[i].checked) {
						const sellerProfileId = selectedSellers[i].value;
						sellerProfileIdArray.push(sellerProfileId);
					}
				}

				barkTrackingLogEvent(
					'seller-list-&-profile',
					'seller-list-request-quote-from-all',
					{
						projectId: projectId,
						...getTrackingData(sellerProfileIdArray, sellerList),
					},
				);

				buyerApi.postBulkResponseAction(
					{
						type: 'quote',
						source: 'bulk-buyer-interaction',
						sellerProfileIdArray,
						projectId,
						bpvid,
					},
					(response) => {
						$('#marketplace-buyer-quote-upsell-modal').modal('hide');
						showSendMessageModal(
							projectId,
							bpvid,
							sellerProfileIdArray,
							sellerList,
							buyerPhone,
						);
					},
					(error) => {
						bugsnagClient &&
							bugsnagClient.notify(
								new Error(
									`Failed to request replies from top 5 on marketplace separated list`,
								),
								{ metaData: error },
							);

						sendToFullList();
					},
				);
			});

		$('#marketplace-buyer-quote-upsell-modal .js-marketplace-see-more-professionals-btn')
			.off('click.see-more-professionals-btn')
			.on('click.see-more-professionals-btn', function () {
				barkTrackingLogEvent(
					'marketplace-seller-list',
					'see - potential - matches - click',
					{
						buyer_user_id: buyerUserId,
						project_id: projectId,
						source: 'request-reply-modal',
					},
				);
				QS.setValue('view', 'full');
				QS.setValue('lt', 'matches');
				QS.setValue('loading-msg', 'loading-professionals');
				location.reload();
			});
	};

	const getTopFiveSuggestedSellers = async (projectId, bpvid) => {
		const options = {
			bpvid: bpvid,
			filterQuery: 'show[filters]=1',
			sort: 'best',
			version: 'v2',
			page: {
				number: 1,
			},
		};

		let topFiveSuggestedSellers = [];

		try {
			const suggestedSellers = await buyerApi.getMatchesListForProject(
				projectId,
				options,
			);

			if (suggestedSellers?.data?.length) {
				topFiveSuggestedSellers = suggestedSellers.data
					.reduce((filtered, item) => {
						if (
							item.attributes.quote_status === null
						) {
							filtered.push({
								sellerIdHash: item.id,
								companyName: item.attributes.company_name,
								starsHtml: ReviewStars().generateStars(item.attributes.reviews_score),
								reviewsCount: item.attributes.reviews_count,
								locationDisplay: item.attributes.location_display_string,
							});
						}
						return filtered;
					}, [])
					.slice(0, 5);
			}
		} catch (error) {
			bugsnagClient &&
				bugsnagClient.notify(
					new Error(
						`Failed to get top 5 suggested sellers for marketplace separated list`,
					),
					{ metaData: error },
				);
		}

		return topFiveSuggestedSellers;
	};

	const sendToFullList = () => {
		QS.setValue('view', 'full');
		QS.setValue('lt', 'matches');
		location.reload();
	};

	const showSendMessageModal = (
		projectId,
		bpvid,
		sellerProfileIdArray,
		sellerList,
		buyerPhone,
	) => {
		if (window.BuyerApp) {
			try {
				const options = {
					hashedProjectId: projectId,
					bpvId: bpvid,
					matchedSellerIds: sellerProfileIdArray,
					buyerPhone,
					sortType: 'best',
					trackingData: getTrackingData(sellerProfileIdArray, sellerList),
					showHeader: false,
					modalOpenDefault: true,
					onSendMessageSuccess: sendToFullList,
					onSendMessageSkip: sendToFullList,
				};
				window.BuyerApp.launchModule(
					'request-multiple-replies',
					'__reqQfromAllBtn',
					options,
				);
			} catch (error) {
				console.log(error);
				sendToFullList();
			}
		} else {
			sendToFullList();
		}
	};

	return {
		show,
	};
}
